import { useEffect } from 'react';
import { Pouzivatel } from '../model/iam/Pouzivatel';
import { ClientStatus } from '../model/ClientStatus';
import Uuid from '../model/Uuid';
import { useClient } from '../context/ClientStatusContext';
import {
  fetchZodpovednyPredkladatelList,
} from '../client/external/iam/pouzivatelListClient';

interface ReturnType {
  pouzivatelia: Pouzivatel[];
  pouzivateliaStatus: ClientStatus;
}

export default (
  reloadData: boolean,
  setReloadData: (reloadData: boolean) => void,
  orgUuid?: Uuid,
): ReturnType => {
  const {
    wrapClient,
    data,
    status,
  } = useClient(fetchZodpovednyPredkladatelList);

  useEffect(() => {
    if (orgUuid && reloadData) {
      wrapClient(orgUuid, null);
      setReloadData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUuid, reloadData]);

  return {
    pouzivatelia: data,
    pouzivateliaStatus: status,
  };
};
